const DSTA = {
  jobTitle: "Software Engineer",
  company: "Defense Science and Technology Agency (DSTA) Singapore",
  duration: "Jul 2023 - Mar 2025",
  description:
    "Developing common frontend and backend libraries for DSTA projects as a Full-Stack Engineer under Enterprise Digital Services",
  jobscope: [
    "Working as a Full-Stack Engineer under Enterprise Digital Services",
  ],
  funFact:
    "My first full time role. Its an eye opening experience as it is also my first time implementing libraries instead of using them!",
};

export default DSTA;
